import type { HTMLAttributes } from "react";
import type { VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { spinnerVariants } from "./spinner-variants";

export interface SpinnerProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof spinnerVariants> {}

function Spinner({ className, size, ...props }: SpinnerProps) {
  return (
    <span className={cn(spinnerVariants({ size }), className)} aria-hidden="true" {...props} />
  );
}

export { Spinner };
